import { 
    sendChatMessage,
    clearChatMessage,
    setSpecialTask,
    setToggleChat,
    setIsLoading,
    setInvoiceDetail,
    setChatContext
} from "../../../constants/model-reducers/common/chatbot.settings";
import { httpPost } from '../../../utils/api.utils';

const extractOrderRequestNumber = (message) => {
    const input = (message || '').trim();
    if (!input) return null;

    const prefixed = input.match(/\b(?:OR|ORD|TEM)\d{5,}\b/i);
    if (prefixed && prefixed[0]) return prefixed[0].toUpperCase();

    return null;
};

const detectOrderIntent = (message) => {
    const text = (message || '').toLowerCase();

    if (text.includes('analyst') || text.includes('assigned')) return 'specific_assigned_analyst';
    if (text.includes('latest activity') || text.includes('progress') || text.includes('comment')) return 'specific_latest_activity';
    if (text.includes('milestone') || text.includes('estimated completion') || text.includes('eta')) return 'specific_milestone_eta';
    if (text.includes('status')) return 'specific_status';
    return 'specific_summary';
};

const detectSpecificFollowUpIntent = (message) => {
    const text = (message || '').toLowerCase();

    if (text.includes('analyst') || text.includes('assigned')) return 'specific_assigned_analyst';
    if (text.includes('latest activity') || text.includes('latest update') || text.includes('progress') || text.includes('comment')) return 'specific_latest_activity';
    if (text.includes('milestone') || text.includes('estimated completion') || text.includes('completion date') || text.includes('eta')) return 'specific_milestone_eta';
    if (text.includes('status') || text.includes('state')) return 'specific_status';

    return null;
};


export const initialState = {
    responceMessage:[],
    hasSpecialTask: false,
    isOpen: false,
    isLoading: false,
    auditId: 0,
    exceptionId: 0,
    isGenerateSummary: false,
    invoiceId: 0,
    step: null,
    auditRulesMode: null,
    auditRuleIdsCsv: null,
    getInvoiceDetailId: false,
    actionKey: null,
    actionLabel: null,

    //Plan Advisor context
    actionButtons: [],
    contextType: "invoice_audit",
    contextPayload: null,
    entrySource: "global_chat",
    actionLabel: null,
    actionUrl: null,
    followUpSuggestions: [],
    orderRequestNumber: null,
    orderRequestId: 0,
    orderIntent: null,
    orderScope: null,
    actionUrl: null,
    followUpSuggestions: [],
    requestFlowType: null,
    changeUserDraft: null,
    otherRequestDraft: null,
    terminateSubscriptionDraft: null,
    portOutDraft: null,
    internationalAccessDraft: null,
    accessoryDraft: null,
    replaceUpgradeDeviceDraft: null,
    newMobileSubscriptionDraft: null,
    changeVendorDraft: null,
    portInDraft: null,
    wirelineTerminateCircuitDraft: null,
    wirelineUpdatePlanDraft: null,
    wirelineOtherRequestDraft: null,
    wirelineChangeVendorDraft: null,
    newCircuitDraft: null,
    selectedAccessories: [],
    accessoryOptions: [],
    quotationDraft: null,
    quotationCheckboxField: null,
    quotationCheckboxOptions: [],
    selectedQuotationCheckboxOptions: [],
}

export const ChatbotActions = {
    sendMessage: (message, auditDetailsId, auditExceptionId, generateSummary = false, invoiceDetailId = 0, hasOpenInvoice = false) => async (dispatch, getState) => { 

        const state = getState();
        const chatbotState = state.chatbot;
        const explicitOrderRequestNumber = extractOrderRequestNumber(message);
        const hasExplicitOrderRequestNumber = !!explicitOrderRequestNumber;
        const explicitOrderIntent = hasExplicitOrderRequestNumber ? detectOrderIntent(message) : null;
        const contextualFollowUpIntent = !hasExplicitOrderRequestNumber && chatbotState.orderRequestNumber
            ? detectSpecificFollowUpIntent(message)
            : null;

        // current step coming from last API response (nextAction)
        const currentStep = hasExplicitOrderRequestNumber ? null : (chatbotState.step || null);

        // invoiceId: either explicit param or stored in state
        const effectiveInvoiceId = hasExplicitOrderRequestNumber ? 0 : (invoiceDetailId || chatbotState.invoiceId || 0);

        const safeJsonParse = (v) => {
            try { return JSON.parse(v); } catch { return null; }
        };

        const ctxPayload =
            typeof chatbotState.contextPayload === "string"
                ? safeJsonParse(chatbotState.contextPayload)
                : chatbotState.contextPayload;

        var data =
        {
            "UserMessage": message,
            "ContextType": chatbotState.contextType,
            "ContextPayload": ctxPayload ?? null,
            "EntrySource": chatbotState.entrySource,
            "AuditDetailsID": auditDetailsId,
            "AuditExceptionID": auditExceptionId,
            "IsGenerateSummary": generateSummary,
            "InvoiceID": effectiveInvoiceId,
            "Step": currentStep,
            "AuditRulesMode": chatbotState.auditRulesMode,
            "AuditRuleIdsCsv": chatbotState.auditRuleIdsCsv,
            "GetInvoiceDetailId": hasOpenInvoice,
            "OrderRequestNumber": hasExplicitOrderRequestNumber ? explicitOrderRequestNumber : chatbotState.orderRequestNumber,
            "OrderRequestId": hasExplicitOrderRequestNumber ? 0 : chatbotState.orderRequestId,
            "OrderIntent": hasExplicitOrderRequestNumber
                ? explicitOrderIntent
                : (contextualFollowUpIntent || chatbotState.orderIntent),
            "OrderScope": (hasExplicitOrderRequestNumber || contextualFollowUpIntent)
                ? "specific"
                : chatbotState.orderScope,
            "SelectedPlanId": Number(ctxPayload?.selectedPlanId ?? 0),
            "SelectedPlanName": ctxPayload?.selectedPlanName ?? null,
            "CircuitTypeId": Number(ctxPayload?.circuitTypeId ?? 0),
            "VendorId": Number(ctxPayload?.vendorId ?? 0),
            "CircuitId": Number(ctxPayload?.circuitId ?? 0),
            "SelectedEquipmentInventoryId": Number(ctxPayload?.selectedEquipmentInventoryId ?? 0),
            "SelectedEquipmentModel": ctxPayload?.selectedEquipmentModel ?? null,
            "SelectedEquipmentMrc": Number(ctxPayload?.equipmentMrc ?? 0),
            "SelectedEquipmentNrc": Number(ctxPayload?.equipmentNrc ?? 0),
            "SelectedEquipmentProductName": ctxPayload?.productName ?? null,
            "SelectedEquipmentTypeId": Number(ctxPayload?.equipmentTypeId ?? 0),
            "SelectedEquipmentStatusId": Number(ctxPayload?.equipmentStatusId ?? 0),
            "RequestFlowType": chatbotState.requestFlowType || null,
            "ChangeUserDraft": chatbotState.changeUserDraft || null,
            "OtherRequestDraft": chatbotState.otherRequestDraft || null,
            "TerminateSubscriptionDraft": chatbotState.terminateSubscriptionDraft || null,
            "PortOutDraft": chatbotState.portOutDraft || null,
            "InternationalAccessDraft": chatbotState.internationalAccessDraft || null,
            "AccessoryDraft": chatbotState.accessoryDraft || null,
            "ReplaceUpgradeDeviceDraft": chatbotState.replaceUpgradeDeviceDraft
                ? {
                    ...chatbotState.replaceUpgradeDeviceDraft,
                    MobileServiceTypeOptions:
                        chatbotState.replaceUpgradeDeviceDraft.MobileServiceTypeOptions
                        ?? chatbotState.replaceUpgradeDeviceDraft.mobileServiceTypeOptions
                        ?? []
                }
                : null,
            "ChangeVendorDraft": chatbotState.changeVendorDraft || null,
            "PortInDraft": chatbotState.portInDraft || null,
            "NewMobileSubscriptionDraft": chatbotState.newMobileSubscriptionDraft || null,
            "WirelineTerminateCircuitDraft":
                chatbotState.wirelineTerminateCircuitDraft || null,
            "NewCircuitDraft": chatbotState.newCircuitDraft || null,
            "QuotationDraft": chatbotState.quotationDraft || null,
            "WirelineChangeVendorDraft": chatbotState.wirelineChangeVendorDraft || null,
        };
        dispatch({
            type: setIsLoading,
            payload: true
        });
        try {
            const response = await httpPost("external/chatbot/chat", data);

            const answer =
                (typeof response === "string" && response.trim())
                    ? response
                    : (typeof response?.answer === "string" && response.answer.trim())
                        ? response.answer
                        : (typeof response?.error === "string" && response.error.trim())
                            ? "I ran into an issue while processing your request. Please try again in a moment."
                            : "I was not able to generate a response. Please try again.";

            const normalized = {
                ...(typeof response === "object" && response ? response : {}),
                answer,
                nextAction: response?.nextAction ?? chatbotState.step ?? null
            };

            const normalizedContextPayload =
                (() => {
                    const base =
                        normalized.contextPayload !== undefined
                            ? normalized.contextPayload
                            : chatbotState.contextPayload;

                    const safeBase =
                        base && typeof base === "object" && !Array.isArray(base)
                            ? base
                            : {};

                    const selectedEquipmentInventoryId =
                        normalized.selectedEquipmentInventoryId !== undefined
                            ? normalized.selectedEquipmentInventoryId
                            : safeBase.selectedEquipmentInventoryId;

                    const selectedEquipmentModel =
                        normalized.selectedEquipmentModel !== undefined
                            ? normalized.selectedEquipmentModel
                            : safeBase.selectedEquipmentModel;

                    // Only enrich when we actually have selected-equipment values
                    if (
                        selectedEquipmentInventoryId !== undefined ||
                        selectedEquipmentModel !== undefined
                    ) {
                        return {
                            ...safeBase,
                            ...(selectedEquipmentInventoryId !== undefined
                                ? { selectedEquipmentInventoryId }
                                : {}),
                            ...(selectedEquipmentModel !== undefined
                                ? { selectedEquipmentModel }
                                : {})
                        };
                    }

                    return base;
                })();

        dispatch({
            type: sendChatMessage,
                payload: normalized.answer,
            loading: false,
                auditDetailsId,
                auditExceptionId,
            isGenerateSummary: false,
                invoiceId: normalized.invoiceId ?? effectiveInvoiceId,
                step: normalized.nextAction ?? null,
            auditRulesMode:
                    normalized.auditRulesMode !== undefined ? normalized.auditRulesMode : chatbotState.auditRulesMode,
            auditRuleIdsCsv:
                    normalized.auditRuleIdsCsv !== undefined ? normalized.auditRuleIdsCsv : chatbotState.auditRuleIdsCsv,
                getInvoiceDetailId: hasOpenInvoice,
                actionIntent: normalized.actionIntent ?? null,
                actionKey: normalized.actionKey ?? null,
                actionLabel: normalized.actionLabel ?? null,
                actionUrl: normalized.actionUrl ?? null,
                followUpSuggestions: normalized.followUpSuggestions ?? [],
                orderRequestNumber: normalized.orderRequestNumber ?? (hasExplicitOrderRequestNumber ? explicitOrderRequestNumber : chatbotState.orderRequestNumber),
                orderRequestId: normalized.orderRequestId ?? (hasExplicitOrderRequestNumber ? 0 : chatbotState.orderRequestId),
                orderIntent: normalized.orderIntent ?? (hasExplicitOrderRequestNumber ? explicitOrderIntent : (contextualFollowUpIntent ?? chatbotState.orderIntent)),
                orderScope: normalized.orderScope ?? ((hasExplicitOrderRequestNumber || contextualFollowUpIntent) ? "specific" : chatbotState.orderScope),
                actionButtons: Array.isArray(normalized.actionButtons) ? normalized.actionButtons : [],
                requestFlowType:
                    normalized.requestFlowType !== undefined
                        ? normalized.requestFlowType
                        : chatbotState.requestFlowType,
                changeUserDraft:
                    normalized.changeUserDraft !== undefined
                        ? normalized.changeUserDraft
                        : chatbotState.changeUserDraft,
                otherRequestDraft:
                    normalized.otherRequestDraft !== undefined
                        ? normalized.otherRequestDraft
                        : chatbotState.otherRequestDraft,
                terminateSubscriptionDraft:
                    normalized.terminateSubscriptionDraft !== undefined
                        ? normalized.terminateSubscriptionDraft
                        : chatbotState.terminateSubscriptionDraft,
                portOutDraft:
                    normalized.portOutDraft !== undefined
                        ? normalized.portOutDraft
                        : chatbotState.portOutDraft,
                internationalAccessDraft:
                    normalized.internationalAccessDraft !== undefined
                        ? normalized.internationalAccessDraft
                        : chatbotState.internationalAccessDraft,
                accessoryDraft:
                    normalized.accessoryDraft !== undefined
                        ? normalized.accessoryDraft
                        : chatbotState.accessoryDraft,
                selectedAccessories:
                    normalized.selectedAccessories !== undefined
                        ? normalized.selectedAccessories
                        : chatbotState.selectedAccessories,
                accessoryOptions:
                    normalized.accessoryOptions !== undefined
                        ? normalized.accessoryOptions
                        : chatbotState.accessoryOptions,
                replaceUpgradeDeviceDraft:
                    normalized.replaceUpgradeDeviceDraft !== undefined
                        ? normalized.replaceUpgradeDeviceDraft
                        : chatbotState.replaceUpgradeDeviceDraft,
                changeVendorDraft:
                    normalized.changeVendorDraft !== undefined
                        ? normalized.changeVendorDraft
                        : chatbotState.changeVendorDraft,
                portInDraft:
                    normalized.portInDraft !== undefined
                        ? normalized.portInDraft
                        : chatbotState.portInDraft,
                newMobileSubscriptionDraft:
                    normalized.newMobileSubscriptionDraft !== undefined
                    ? normalized.newMobileSubscriptionDraft
                        : chatbotState.newMobileSubscriptionDraft,
                wirelineTerminateCircuitDraft:
                    normalized.wirelineTerminateCircuitDraft !== undefined
                        ? normalized.wirelineTerminateCircuitDraft
                        : chatbotState.wirelineTerminateCircuitDraft,
                newCircuitDraft:
                    normalized.newCircuitDraft !== undefined
                        ? normalized.newCircuitDraft
                        : chatbotState.newCircuitDraft,
                contextType:
                normalized.contextType !== undefined
                    ? normalized.contextType
                    : chatbotState.contextType,
                contextPayload: normalizedContextPayload,
                entrySource:
                normalized.entrySource !== undefined
                    ? normalized.entrySource
                        : chatbotState.entrySource,
                wirelineChangeVendorDraft:
                    normalized.wirelineChangeVendorDraft !== undefined
                        ? normalized.wirelineChangeVendorDraft
                        : chatbotState.wirelineChangeVendorDraft,
                // Wireline
                quotationDraft:
                    normalized.quotationDraft !== undefined
                        ? normalized.quotationDraft
                        : chatbotState.quotationDraft,
                quotationCheckboxField:
                    normalized.quotationCheckboxField !== undefined
                        ? normalized.quotationCheckboxField
                        : chatbotState.quotationCheckboxField,
                quotationCheckboxOptions:
                    normalized.quotationCheckboxOptions !== undefined
                        ? normalized.quotationCheckboxOptions
                        : chatbotState.quotationCheckboxOptions,
                selectedQuotationCheckboxOptions:
                    normalized.selectedQuotationCheckboxOptions !== undefined
                        ? normalized.selectedQuotationCheckboxOptions
                        : chatbotState.selectedQuotationCheckboxOptions,
            });
            return normalized;
        } catch (error) {
            dispatch({
                type: sendChatMessage,
                payload: "Sorry — something went wrong while processing your request. Please try again.",
                loading: false,
                auditDetailsId,
                auditExceptionId,
                isGenerateSummary: false,
                invoiceId: effectiveInvoiceId,
                step: null,
                auditRulesMode: chatbotState.auditRulesMode,
                auditRuleIdsCsv: chatbotState.auditRuleIdsCsv,
                getInvoiceDetailId: hasOpenInvoice,
                actionIntent: null,
                actionKey: null,
                actionLabel: null,
                actionUrl: null,
                followUpSuggestions: [],
                orderRequestNumber: chatbotState.orderRequestNumber,
                orderRequestId: chatbotState.orderRequestId,
                orderIntent: chatbotState.orderIntent,
                orderScope: chatbotState.orderScope,
                actionButtons: null,
                requestFlowType: null,
                changeUserDraft: null,
                otherRequestDraft: null,
                terminateSubscriptionDraft: null,
                portOutDraft: null,
                internationalAccessDraft: null,
                accessoryDraft: null,
                selectedAccessories: [],
                accessoryOptions: [],
                replaceUpgradeDeviceDraft: null,
                changeVendorDraft: null,
                portInDraft: null,
                newMobileSubscriptionDraft: null,
                wirelineTerminateCircuitDraft: null,
                wirelineUpdatePlanDraft: null,
                wirelineOtherRequestDraft: null,
                wirelineChangeVendorDraft: null,
                newCircuitDraft: null,
                quotationDraft: null,
                quotationCheckboxField: null,
                quotationCheckboxOptions: [],
                selectedQuotationCheckboxOptions: [],

            });
            return { error };
        } finally {
        dispatch({
            type: setIsLoading,
            payload: false
        });
    }
    },
    clearMessage: (invoiceAuditDetailsId = 0, exceptionDetailsID = 0, generateSummary = false, invoiceDetailId = 0, hasOpenInvoice = false) => (dispatch, state) => {
        dispatch({
            type: clearChatMessage,
            payload: [],
            auditDetailsId: invoiceAuditDetailsId,
            auditExceptionId: exceptionDetailsID,
            isGenerateSummary: generateSummary,
            invoiceId: hasOpenInvoice ? invoiceDetailId : 0,
            getInvoiceDetailId: hasOpenInvoice,
            step: null
        })
    },
    toggleChat: (isOpen) => (dispatch) => {
        dispatch({
            type: setToggleChat,
            payload: isOpen
        })
    },
    configSpecialTask: (hasSpecialTask, invoiceAuditDetailsId = 0, exceptionDetailsID = 0) => (dispatch, state) => {
        dispatch({
            type: setSpecialTask,
            payload: hasSpecialTask,
            auditDetailsId: invoiceAuditDetailsId,
            auditExceptionId: exceptionDetailsID,
            isGenerateSummary: true
        })
    },
    getInvoiceDetail: (invoiceDetailId, hasOpenInvoice) => (dispatch, state) => {
        dispatch({
            type: setInvoiceDetail,
            payload: invoiceDetailId,
            getInvoiceDetailId: hasOpenInvoice
        })
    },
    setContext: (contextType, contextPayload = null, entrySource = "global_chat") => (dispatch) => {
        dispatch({
            type: setChatContext,
            contextType,
            contextPayload,
            entrySource
        });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch(action.type) {
        case sendChatMessage:
            return {
                ...state,
                responceMessage: action.payload,
                isLoading: action.loading,
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary,
                invoiceId: action.invoiceId,
                step: action.step || null,
                auditRulesMode: action.auditRulesMode || null,
                auditRuleIdsCsv: action.auditRuleIdsCsv || null,
                getInvoiceDetailId: action.getInvoiceDetailId,
                actionIntent: action.actionIntent,
                actionKey: action.actionKey,
                actionLabel: action.actionLabel,
                actionUrl: action.actionUrl,
                followUpSuggestions: action.followUpSuggestions,
                orderRequestNumber: action.orderRequestNumber,
                orderRequestId: action.orderRequestId,
                orderIntent: action.orderIntent,
                orderScope: action.orderScope,
                actionButtons: action.actionButtons ?? null,
                requestFlowType: action.requestFlowType,
                changeUserDraft: action.changeUserDraft,
                otherRequestDraft: action.otherRequestDraft,
                terminateSubscriptionDraft: action.terminateSubscriptionDraft,
                portOutDraft: action.portOutDraft,
                internationalAccessDraft: action.internationalAccessDraft,
                accessoryDraft: action.accessoryDraft,
                selectedAccessories: action.selectedAccessories || [],
                accessoryOptions: action.accessoryOptions || [],
                replaceUpgradeDeviceDraft: action.replaceUpgradeDeviceDraft,
                changeVendorDraft: action.changeVendorDraft,
                portInDraft: action.portInDraft,
                newMobileSubscriptionDraft: action.newMobileSubscriptionDraft,
                wirelineTerminateCircuitDraft: action.wirelineTerminateCircuitDraft,
                wirelineUpdatePlanDraft: action.wirelineUpdatePlanDraft,
                wirelineOtherRequestDraft: action.wirelineOtherRequestDraft,
                wirelineChangeVendorDraft: action.wirelineChangeVendorDraft,
                newCircuitDraft: action.newCircuitDraft,
                quotationDraft: action.quotationDraft,
                quotationCheckboxField: action.quotationCheckboxField || null,
                quotationCheckboxOptions: action.quotationCheckboxOptions || [],
                selectedQuotationCheckboxOptions: action.selectedQuotationCheckboxOptions || [],
                contextType: action.contextType,
                contextPayload: action.contextPayload,
                entrySource: action.entrySource
            }
        case clearChatMessage:
            return {
                ...state,
                responceMessage: "",
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary,
                invoiceId: action.invoiceId,
                step: null,
                auditRulesMode: null,
                auditRuleIdsCsv: null,
                getInvoiceDetailId: action.getInvoiceDetailId,
                actionKey: null,
                actionLabel: null,
                actionUrl: null,
                followUpSuggestions: [],
                orderRequestNumber: null,
                orderRequestId: 0,
                orderIntent: null,
                orderScope: null,
                contextType: null,
                contextPayload: null,
                requestFlowType: null,
                changeUserDraft: null,
                otherRequestDraft: null,
                terminateSubscriptionDraft: null,
                portOutDraft: null,
                internationalAccessDraft: null,
                accessoryDraft: null,
                selectedAccessories: [],
                accessoryOptions: [],
                replaceUpgradeDeviceDraft: null,     
                changeVendorDraft: null,
                portInDraft: null,
                newMobileSubscriptionDraft: null,
                wirelineTerminateCircuitDraft: null,
                wirelineUpdatePlanDraft: null,
                wirelineOtherRequestDraft: null,
                wirelineChangeVendorDraft: null,
                newCircuitDraft: null,
                quotationDraft: null,
                quotationCheckboxField: null,
                quotationCheckboxOptions: [],
                selectedQuotationCheckboxOptions: [],
            }
        case setSpecialTask:
            return {
                ...state,
                hasSpecialTask: action.payload,
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary
            }
        case setInvoiceDetail:
            return {
                ...state,
                invoiceId: action.payload,
                getInvoiceDetailId: action.getInvoiceDetailId,
                step: action.step !== undefined ? action.step : state.step
            }
        case setToggleChat: 
            return {
                ...state,
                isOpen: action.payload
            }
        case setIsLoading:
            return {
                ...state,
                isLoading: action.payload
            }
        case setChatContext:
            return {
                ...state,
                contextType: action.contextType,
                contextPayload: action.contextPayload,
                entrySource: action.entrySource,
                step: null,
                responceMessage: "",
                actionButtons: [],
                actionKey: null,
                actionLabel: null,
                actionUrl: null,
                followUpSuggestions: [],
                requestFlowType: null,
                changeUserDraft: null,
                otherRequestDraft: null,
                terminateSubscriptionDraft: null,
                portOutDraft: null,
                internationalAccessDraft: null,
                accessoryDraft: null,
                selectedAccessories: [],
                accessoryOptions: [],
                replaceUpgradeDeviceDraft: null,
                changeVendorDraft: null,
                portInDraft: null,
                followUpSuggestions: [],
                newMobileSubscriptionDraft: null,
                wirelineTerminateCircuitDraft: null,
                wirelineUpdatePlanDraft: null,
                wirelineOtherRequestDraft: null,
                wirelineChangeVendorDraft: null,
                newCircuitDraft: null,
                quotationDraft: null,
                quotationCheckboxField: null,
                quotationCheckboxOptions: [],
                selectedQuotationCheckboxOptions: [],
            }
        default:
            return state;
    }
}